<app-loader *ngIf="authLoading || ADFSLoading"></app-loader>
<div class="auth-form" *ngIf="!ADFSLoading">
  <div class="mt-150">
    <span class="title title--big">Вход в {{ Enums.projectName }}</span>
  </div>
  <form [formGroup]="authForm" (ngSubmit)="onSubmitAuthForm()">
    <div class="mt-32">
      <div class="mt-4">
        <app-field>
          <label>Логин</label>
          <input
            class="input-text"
            id="login"
            type="text"
            formControlName="login"
            [ngClass]="{
              'input-text-validation input-text--invalid': authErrorLogin
            }"
            required
          />
        </app-field>
      </div>
      <div class="mt-8">
        <app-field-password>
          <label>Пароль</label>
          <input
            class="input-text"
            id="password"
            type="password"
            formControlName="password"
            [ngClass]="{
              'input-text-validation input-text--invalid': authErrorLogin
            }"
            required
          />
        </app-field-password>
      </div>
      <div class="grid grid--va-middle mt-16">
        <div class="grid__box grid__box--size-min grid__box--pull-left">
          <button class="button" type="submit" [disabled]="!authForm.valid" id="appInputSubmit">Войти</button>
        </div>
        <div class="grid__box grid__box--size-min grid__box--pull-right">
          <a *ngIf="!isUseADFS" routerLink="{{ '/' + AUTH_PATHS.recovery_access }}" class="link link--gray" id="appRecoveryPassword">Напомнить пароль</a>
          <a *ngIf="isUseADFS" href="{{ ADFSSettings.adfs_pwd_reset_url }}" target="_blank" class="link link--gray" id="appRecoveryPasswordADFS">Восстановить пароль</a>
        </div>
      </div>
    </div>
  </form>
  <div class="mt-16" *ngIf="authError">
    <app-message [type]="'error'">
      <div message-content>{{ authError }}</div>
    </app-message>
  </div>
</div>
